/* This component DELETES one entry from the historys collection in MongoDB. */

import React, { useState }                      from 'react'
import axios                                    from 'axios'
import Box                                      from '@material-ui/core/Box'
import { CLIENT_PUBLIC_TOKEN }                  from '../config'
import Grid                                     from '@material-ui/core/Grid'
import HistoryTitleReadComponent                from './HistoryTitleReadComponent'
import { node_server }                          from '../Helpers'

const HistoryEntryDeleteComponent = () => {

   /* This causes the HistoryTitleReadComponent to re-render on the deletioon and show the
      new list of titles with the deleted one having been removed. */
   const [ data,                                setData  ]  =  useState([])
   
   const handleClick = (id) => {
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      axios.delete(node_server + `history/${id}`)
         .then( res => res.data )
         .then( data => {
            setData(data.allHistoryTitles)
         })
         .catch( ( error, msg ) => {
            console.error('error and msg are', error, msg)
         } )
   }

   return (
      <Box style={{ marginTop: '6rem', marginBottom: '1rem' }} >
         <Grid>
            <HistoryTitleReadComponent data={data} handleClick={handleClick} />
         </Grid>
      </Box>
   )
}

export default HistoryEntryDeleteComponent

